"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _styles2 = require("@mui/material/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _ui = require("@alycecom/ui");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    button: {
      fontWeight: 'normal'
    },
    truncated: function truncated(_ref2) {
      var lineHeight = _ref2.lineHeight,
          lines = _ref2.lines;
      return {
        overflow: 'hidden',
        position: 'relative',
        maxHeight: lineHeight * (lines + 1),
        marginBottom: spacing(2),
        '&:after': {
          content: "''",
          position: 'absolute',
          bottom: 0,
          right: 0,
          width: '100%',
          height: lineHeight * 3,
          background: "linear-gradient(to bottom, ".concat((0, _styles2.alpha)(palette.common.white, 0), ", ").concat((0, _styles2.alpha)(palette.common.white, 1), " 80%)")
        }
      };
    }
  };
});

var TruncatedText = function TruncatedText(_ref3) {
  var children = _ref3.children,
      _ref3$lines = _ref3.lines,
      lines = _ref3$lines === void 0 ? 3 : _ref3$lines,
      _ref3$lineHeight = _ref3.lineHeight,
      lineHeight = _ref3$lineHeight === void 0 ? 24 : _ref3$lineHeight,
      _ref3$overrideClasses = _ref3.overrideClasses,
      overrideClasses = _ref3$overrideClasses === void 0 ? {} : _ref3$overrideClasses;
  var truncateHeight = lineHeight * (lines + 1);
  var classes = useStyles({
    lineHeight,
    lines
  });
  var textRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isTruncatedOptions = _useState2[0],
      setIsTruncatedOptions = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      useTruncated = _useState4[0],
      setUseTruncated = _useState4[1];

  var toggleTruncate = (0, _react.useCallback)(function () {
    return setIsTruncatedOptions(!isTruncatedOptions);
  }, [isTruncatedOptions]);
  (0, _react.useEffect)(function () {
    if (textRef.current) {
      if (textRef.current.offsetHeight > truncateHeight) {
        setIsTruncatedOptions(true);
        setUseTruncated(true);
      }
    }
  }, [textRef, truncateHeight]);
  (0, _react.useEffect)(function () {
    var current = textRef.current;

    if (isTruncatedOptions && current) {
      current.scrollTop = 0;
    }
  }, [textRef, isTruncatedOptions]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: !isTruncatedOptions,
    collapsedSize: truncateHeight
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    ref: textRef,
    className: (0, _classnames.default)({
      [classes.truncated]: isTruncatedOptions,
      [overrideClasses.truncated]: isTruncatedOptions,
      [overrideClasses.nonTruncated]: !isTruncatedOptions
    })
  }, children)), useTruncated && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1,
    mb: 2,
    className: overrideClasses.buttonWrapper
  }, /*#__PURE__*/_react.default.createElement(_ui.LinkButton, {
    className: (0, _classnames.default)(classes.button, overrideClasses.button),
    onClick: toggleTruncate
  }, "Show ", isTruncatedOptions ? 'more' : 'less')));
};

var _default = /*#__PURE__*/(0, _react.memo)(TruncatedText);

exports.default = _default;